import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  endUserSession,
  extendUserSession,
  selectExtendSession,
  selectIsUserActive,
  selectLogoutSession,
  selectSessionTimedOut,
  selectUserActivityRecorded,
  selectUserActivityRecordedAt,
  setUserActivityRecorded,
} from '@ra-state';
import { AppState } from '../common-admin.model';
@Injectable({
  providedIn: 'root',
})
export class SessionManagementFacade {
  private readonly store$ = inject<Store<AppState>>(Store);

  userActivityRecorded$ = this.store$.select(selectUserActivityRecorded);
  userActivityRecordedAt$ = this.store$.select(selectUserActivityRecordedAt);
  userActive$ = this.store$.select(selectIsUserActive);
  sessionTimedOut$ = this.store$.select(selectSessionTimedOut);
  extendSession$ = this.store$.select(selectExtendSession);
  logoutSession$ = this.store$.select(selectLogoutSession);

  extendUserSession(): void {
    this.store$.dispatch(extendUserSession());
  }

  endUserSession(): void {
    this.store$.dispatch(endUserSession());
  }

  setUserActivityRecorded(value: boolean): void {
    this.store$.dispatch(setUserActivityRecorded({ value: value }));
  }
}
